import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "diamond_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API, withCredentials: true });

// Fire-and-forget behavioural signal (never blocks the UI).
export function recordSignal(type, subject, detail) {
  try { api.post("/me/signal", { type, subject, detail }).catch(() => {}); } catch (e) {}
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const org = localStorage.getItem("diamond_org");
  if (org) config.headers["X-Org-Id"] = org;
  const company = localStorage.getItem("diamond_company");
  if (company) config.headers["X-Company-Id"] = company;
  return config;
});

export function formatError(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Stream a chat completion over SSE via fetch (POST).
 * callbacks: { onMeta, onToken, onDone, onError }
 * Returns an abort function.
 */
export function streamChat(path, body, callbacks, signal) {
  const t = getToken();
  const org = localStorage.getItem("diamond_org");
  const company = localStorage.getItem("diamond_company");
  const headers = { "Content-Type": "application/json", Authorization: t ? `Bearer ${t}` : "" };
  if (org) headers["X-Org-Id"] = org;
  if (company) headers["X-Company-Id"] = company;
  fetch(`${API}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
    credentials: "include",
    signal,
  })
    .then(async (res) => {
      if (!res.ok || !res.body) {
        let msg = "Provider unavailable";
        try {
          const j = await res.json();
          msg = formatError(j.detail) || msg;
        } catch (e) {}
        callbacks.onError?.(msg);
        return;
      }
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop() || "";
        for (const part of parts) {
          const line = part.trim();
          if (!line.startsWith("data:")) continue;
          try {
            const evt = JSON.parse(line.slice(5).trim());
            if (evt.type === "meta") callbacks.onMeta?.(evt);
            else if (evt.type === "token") callbacks.onToken?.(evt.delta);
            else if (evt.type === "done") callbacks.onDone?.(evt);
            else if (evt.type === "error") callbacks.onError?.(evt.message);
          } catch (e) {}
        }
      }
    })
    .catch((e) => {
      if (e.name !== "AbortError") callbacks.onError?.(e.message || "Connection lost");
    });
}
